
async function clientSdkToPromise(name, resultCallbackName, params = {}) {
  return new Promise((resolve, reject) => {
    try {
      window.flutter_inappwebview.callHandler(name, JSON.stringify(params));
      if (resultCallbackName) {
        window[resultCallbackName] = resolve;
      }
    } catch (e) {
      reject(e);
      
    }
  });
}

export async function getClientInfo() {
  //   return {
  //     userId: "62f20db8d7aa790006db645b",
  //     country: "GT",
  //     token:
  //       "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyZjIwZGI4ZDdhYTc5MDAwNmRiNjQ1YiIsImRldmVsb3AiOjAsImlhdCI6MTY5OTMyNzE4OSwiZXhwIjoxNzMwODYzMTg5fQ.LrAhfirB48FLc18x5-qs5IvG9ZaQL9aVqYj2SpBLJwo",
  //     channel: "googleplay",
  //     version: "1.19.1",
  //     opentoken:
  //       "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJiZWVreWMiLCJzdWIiOiJhdXRoIiwiYXVkIjoiNjJmMjBkYjhkN2FhNzkwMDA2ZGI2NDViIiwiZXhwIjoxNjk5MzMxMzI1LCJpYXQiOjE2OTkzMjc3MjV9.itNyUfaDcmx9olCUKDDFMFrSfA9gR7A8ynZnHJH8hqA",
  //     resourceVersion:
  //       "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJiZWVreWMiLCJzdWIiOiJhdXRoIiwiYXVkIjoiNjJmMjBkYjhkN2FhNzkwMDA2ZGI2NDViIiwiZXhwIjoxNjk5MzMxMzI1LCJpYXQiOjE2OTkzMjc3MjV9.itNyUfaDcmx9olCUKDDFMFrSfA9gR7A8ynZnHJH8hqA&resourceVersion=v100.16.10",
  //     language: "sc",
  //     languageIso: "zh_Hans",
  //   };
  const result = await clientSdkToPromise("getClientInfo", "setClientInfo", {
    message: "getClientInfo",
  });
  // console.log("=================getClientInfo", result);
  return JSON.parse(result);
}
